import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { GetJourneyRequestDto, GetJourneyResponseDto } from '../../dto';

export type getJourneyOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function getJourney(
  baseUrl: string,
  payload: GetJourneyRequestDto,
  options?: getJourneyOptions,
): Promise<IHttpResponse<GetJourneyResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<void> = {
    url: `${baseUrl}/reflexive-journey/api/v1/journeys/${payload.journeyId}`,
    method: 'GET',
    headers,
    queryParams: {
      env: payload.env,
    },
    schemas: {
      query: GetJourneyRequestDto.pick({ env: true }),
      response: GetJourneyResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
